import { useContext, useEffect, useRef, useState } from 'react'
//import doExpColVisualUnit from "../../GlobalMethods";
import {
    useCheckDeleteWorkspaceMutation,
    useCreateNewVisualUnitMutation,
    useDeleteWorkspaceMutation,
    useDetachWorkspaceMutation,
    useEditDashboardMutation,
    useFetchDashboardMutation,
    useFetchDashBoardVUsMutation,
    useReorderDashBoardVUsMutation,
} from '../../Redux/Workspace/workspaceActionsSlice'
import Dialog from '../../GenericComponents/dialog'
import { FoundationsButton } from '../../GenericComponents/button'
import { useDispatch, useSelector } from 'react-redux'
import { AppState, RootState } from '../../Redux/store'

import Sortable from 'sortablejs'
import ReorderReportsDialog from './ReorderReportsDialog'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit'
// TO DO : STORE ALL THE DIALOG IN A SEPERATE FOLDER AND CALL THEM TO USE -- HARSH

declare let window: any
const UnicornApp = window.unicornInstance as any

function WorkspaceActionsDropdown(props: {
    WorkspaceId: number
    visualUnitsData: any
    updateAllTableVUsOrSpecific: (key: keyof VisualUnitApiDTO_VisualUnit_Extended, value: any, limit?: number,VuId?:number) => void
    onRefresh: () => void
    onClickSendEmailasPDF: () => void
    onAddWorkspaceClick: () => void
    onClickEditWorkspace: () => void
    onDeleteWorkspaceClick: () => void
    onDeatchWorkspaceClick: () => void
    onClickShareWorkspace: () => void
    onClickAttachExisting: () => void
    onClickCopyExisting: () => void
    onClickAddNewReport: () => void
    onclickReorderReports: () => void
}) {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [checkDeleteWorkspace] = useCheckDeleteWorkspaceMutation()
    const [deleteWorkspace] = useDeleteWorkspaceMutation()
    const [detachWorkspace] = useDetachWorkspaceMutation()
    const [createNewVisualUnit] = useCreateNewVisualUnitMutation()
    const [fetchDashboard] = useFetchDashboardMutation()
    const [editDashboard] = useEditDashboardMutation()
    const [newVisualUnitId, setNewVisualUnitId] = useState(null)
    const [isEmailSent, setIsEmailSent] = useState(false)
    const [isDialogOpen, setIsDialogOpen] = useState(false)

    const [vuSummaryHtml, setVuSummaryHtml] = useState<string>('')
    const [vuReportHtml, setVuReportHtml] = useState<string>('')
    const [reorderReportLoading, setReorderReportLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)
    const [isreorderDialogOpen, setReorderDialogOpen] = useState(false)

    const [reorderDashBoardVUs, { isLoading: isReordering, error: reorderError }] =
        useReorderDashBoardVUsMutation()
    const [fetchDashBoardVUs] = useFetchDashBoardVUsMutation()

    const [isHovered, setIsHovered] = useState(false)

    const closeDropdown = () => {
        setIsHovered(false)
    }
    const workspaceActions = useSelector((state: AppState) =>
        state.WorkspaceActions.workspace_Actions_State.find(
            (item: any) => item.workspaceId == props.WorkspaceId
        )
    )
    useEffect(() => {}, [workspaceActions])

    const doExpAllVisualUnits = () => {
        props.updateAllTableVUsOrSpecific('Collapsed', false, 10)
    }

    const doColAllVisualUnits = () => {
        props.updateAllTableVUsOrSpecific('Collapsed', true)
    }

    // This function is unused -- Steven 
    // const handleFetchDashBoardVUs = () => {
    //     setLoading(true)
    //     setError(null)
    //     try {
    //         const formData = {
    //             dashBoardId: props.WorkspaceId,
    //         }
    //         fetchDashBoardVUs(formData)
    //             .unwrap()
    //             .then((response) => {
    //                 if (response != null) {
    //                     var resultData = response.data
    //                     if (resultData != null) {
    //                         if (response.statusCode == 200) {
    //                             if (resultData.vuSummaryCount > 0 || resultData.vuReportCount > 0) {
    //                                 setVuSummaryHtml(resultData.vuDataSummariesAsHtml)
    //                                 setVuReportHtml(resultData.vuDataReportsAsHtml)
    //                                 setReorderDialogOpen(true)
    //                             } else {
    //                                 setError('No visual units available for reordering.')
    //                             }
    //                         } else {
    //                             setError('Failed to fetch visual units.')
    //                         }
    //                     }
    //                 }
    //             })
    //     } catch (err) {
    //         setError('An error occurred while fetching visual units.')
    //     } finally {
    //         setLoading(false)
    //     }
    // }
    const extractIdsFromHtml = (selector: string): number[] => {
        const container = document.querySelector(selector)
        if (!container) return []
        return Array.from(container.children).map((child) => {
            const match = child.id.match(/vu_reorder_(\d+)/)
            return match ? parseInt(match[1], 10) : 0
        })
    }
    const handleSaveChanges = () => {
        setLoading(true)
        try {
            const summaryNormalVUIds = extractIdsFromHtml('#vu_summary_reorder_list')
            const reportNormalVUIds = extractIdsFromHtml('#vu_report_reorder_list')
            const formData = new FormData()

            formData.append('dashBoardId', '' + props.WorkspaceId)
            summaryNormalVUIds.forEach((id) => formData.append('summaryNormalVUIds', id.toString()))
            reportNormalVUIds.forEach((id) => formData.append('reportNormalVUIds', id.toString()))

            reorderDashBoardVUs(formData)
                .unwrap()
                .then((response) => {
                    if (response.statusCode === 201) {
                        FoundationsGenericToaster('success', 'Reports reordered successfully.')
                        setReorderDialogOpen(false)
                        props.onRefresh()
                    } else {
                        FoundationsGenericToaster(
                            'error',
                            'Sorry, reports reordered failed. Please try again.'
                        )
                        setError('Failed to save changes.')
                        setReorderDialogOpen(false)
                    }
                })
        } catch (err) {
            setError('An error occurred while saving changes.')
        } finally {
            setLoading(false)
        }
    }

    const initializeSortable = () => {
        const summaryList = document.getElementById('vu_summary_reorder_list')
        const reportList = document.getElementById('vu_report_reorder_list')

        if (summaryList) Sortable.create(summaryList) // TODO: Use React sortable
        if (reportList) Sortable.create(reportList)
    }

    useEffect(() => {
        if (vuSummaryHtml || vuReportHtml) {
            initializeSortable()
        }
    }, [vuSummaryHtml, vuReportHtml])

    return (
        <div
            className="workspace-actions-container"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                position: 'relative',
                display: 'inline-block',
            }} // Ensure dropdown is positioned correctly
        >
            <a id="workspace_action_el" className="cursor-pointer">
                Workspace Actions
                <span className="image smaller"> ▼</span>
            </a>
            <>
                <div id="display_workspace_actions">
                    <ul
                        id="workspace_action_new_dropdown_el "
                        className="dropdown-menu "
                        style={{
                            display: isHovered ? 'block' : 'none',
                            height: 'auto',
                            right: 0,
                            left: 'auto',
                        }}
                    >
                        <>
                            {workspaceActions?.isFavorites ? (
                                <>
                                    <li
                                        id="click_refresh_workspace"
                                        className="dropdown-item cursor-pointer"
                                        onClick={() => {
                                            props.onRefresh()
                                            closeDropdown()
                                        }}
                                    >
                                        Refresh this workspace
                                    </li>

                                    {workspaceActions?.showEmailPDF && (
                                        <li
                                            className="dropdown-item cursor-pointer email-workspace-pdf"
                                            onClick={() => {
                                                props.onClickSendEmailasPDF()
                                                closeDropdown()
                                            }}
                                        >
                                            Email Workspace as PDF
                                        </li>
                                    )}
                                </>
                            ) : (
                                <>
                                    {!workspaceActions?.isKMIs && (
                                        <>
                                            {workspaceActions?.showAddWorkspace ? (
                                                <li
                                                    id="dashboard_menu_showAddNewDashBoardDialog"
                                                    className="dropdown-item cursor-pointer"
                                                    onClick={(event) => {
                                                        event.stopPropagation()
                                                        props.onAddWorkspaceClick()
                                                        closeDropdown()
                                                    }}
                                                >
                                                    Add new workspace
                                                </li>
                                            ) : (
                                                <li
                                                    id="dashboard_menu_showAddNewDashBoardDialog_disabled"
                                                    className="dropdown-item-disabled"
                                                    title="Security privilege is not assigned for this action."
                                                >
                                                    Add new workspace
                                                </li>
                                            )}
                                        </>
                                    )}
                                    {!workspaceActions?.isFavorites &&
                                        !workspaceActions?.isKMIs && (
                                            <>
                                                {workspaceActions?.showEditWorkspaceOption ? (
                                                    <li
                                                        id="dashboard_menu_showEditDashBoardDialog"
                                                        className="dropdown-item cursor-pointer"
                                                        onClick={(event) => {
                                                            event.stopPropagation()
                                                            props.onClickEditWorkspace()
                                                            closeDropdown()
                                                        }}
                                                    >
                                                        Edit this workspace
                                                    </li>
                                                ) : (
                                                    <li
                                                        id="dashboard_menu_showEditDashBoardDialog_disabled"
                                                        className="dropdown-item-disabled"
                                                        title="Security privilege is not assigned for this action."
                                                    >
                                                        Edit this workspace
                                                    </li>
                                                )}
                                            </>
                                        )}
                                    <>
                                        <li
                                            id="click_refresh_workspace"
                                            className="dropdown-item cursor-pointer"
                                            onClick={() => {
                                                props.onRefresh()
                                                closeDropdown()
                                            }}
                                        >
                                            Refresh this workspace
                                        </li>
                                        <li
                                            id="dashboard_menu_expandAllReports"
                                            className="dropdown-item cursor-pointer"
                                            onClick={() => {
                                                doExpAllVisualUnits()
                                                closeDropdown()
                                            }}
                                        >
                                            Expand first 10 reports
                                        </li>
                                        <li
                                            id="dashboard_menu_collapseAllReports"
                                            className="dropdown-item cursor-pointer"
                                            onClick={() => {
                                                doColAllVisualUnits()
                                                closeDropdown()
                                            }}
                                        >
                                            Collapse all reports
                                        </li>
                                    </>

                                    {workspaceActions?.showDeleteWorkspaceOption ? (
                                        <li
                                            id="dashboard_menu_showDeleteDashBoardDialog"
                                            className="dropdown-item cursor-pointer"
                                            onClick={(event) => {
                                                event.stopPropagation()
                                                props.onDeleteWorkspaceClick()
                                                closeDropdown()
                                            }}
                                        >
                                            Delete this workspace
                                        </li>
                                    ) : workspaceActions?.appGUID ? (
                                        <li
                                            id="dashboard_menu_showDeleteDashBoardDialog_disabled"
                                            className="dropdown-item-disabled"
                                            title="Cannot delete software restricted workspace"
                                        >
                                            Delete this workspace
                                        </li>
                                    ) : (
                                        <li
                                            id="dashboard_menu_showDeleteDashBoardDialog_disabled"
                                            className="dropdown-item-disabled"
                                            title="Security privilege is not assigned for this action."
                                        >
                                            Delete this workspace
                                        </li>
                                    )}
                                    {workspaceActions?.showDetachOption ? (
                                        <li
                                            id="dashboard_menu_showDetachDashBoardDialog"
                                            className="dropdown-item cursor-pointer"
                                            onClick={(event) => {
                                                event.stopPropagation()
                                                props.onDeatchWorkspaceClick()
                                                closeDropdown()
                                            }}
                                        >
                                            Detach this workspace
                                        </li>
                                    ) : workspaceActions?.appGUID ? (
                                        <li
                                            id="dashboard_menu_showDetachDashBoardDialog_disabled"
                                            className="dropdown-item-disabled"
                                            title="Cannot detach software restricted workspace"
                                        >
                                            Detach this workspace
                                        </li>
                                    ) : (
                                        <li
                                            id="dashboard_menu_showDetachDashBoardDialog_disabled"
                                            className="dropdown-item-disabled"
                                            title="Security privilege is not assigned for this action."
                                        >
                                            Detach this workspace
                                        </li>
                                    )}
                                    <div>
                                        {workspaceActions?.showShareOption ? (
                                            <li
                                                id="dashboard_menu_showShareDashBoardDialog"
                                                className="dropdown-item cursor-pointer"
                                                onClick={(event) => {
                                                    event.stopPropagation()
                                                    props.onClickShareWorkspace()
                                                    closeDropdown()
                                                }}
                                            >
                                                Share this workspace
                                            </li>
                                        ) : (
                                            <li
                                                id="dashboard_menu_showShareDashBoardDialog_disabled"
                                                className="dropdown-item-disabled"
                                                title="Security privilege is not assigned for this action."
                                            >
                                                Share this workspace
                                            </li>
                                        )}
                                    </div>

                                    {workspaceActions?.showAddWorkspaceReport ? (
                                        <li
                                            id="dashboard_menu_showCreateNewVisualUnitDialog"
                                            className="dropdown-item cursor-pointer divider"
                                            onClick={() => {
                                                props.onClickAddNewReport()
                                                closeDropdown()
                                            }}
                                        >
                                            Add new report
                                        </li>
                                    ) : (
                                        <li
                                            id="dashboard_menu_showCreateNewVisualUnitDialog_disabled"
                                            className="dropdown-item-disabled divider"
                                            title="Security privilege is not assigned for this action."
                                        >
                                            Add new report
                                        </li>
                                    )}
                                    {workspaceActions?.showAttachReportOption ? (
                                        <li
                                            id="dashboard_menu_showAttachExistingVisualUnitDialog"
                                            className="dropdown-item cursor-pointer"
                                            onClick={(event) => {
                                                event.stopPropagation()
                                                props.onClickAttachExisting()
                                                closeDropdown()
                                            }}
                                        >
                                            Attach existing report
                                        </li>
                                    ) : (
                                        <li
                                            id="dashboard_menu_showAttachExistingVisualUnitDialog_disabled"
                                            className="dropdown-item-disabled"
                                            title="Security privilege is not assigned for this action."
                                        >
                                            Attach existing report
                                        </li>
                                    )}
                                    {workspaceActions?.CopyExistingReport ? (
                                        <li
                                            id="dashboard_menu_showCopyExistingVisualUnitDialog"
                                            className="dropdown-item cursor-pointer"
                                            onClick={(event) => {
                                                event.stopPropagation()
                                                props.onClickCopyExisting()
                                                closeDropdown()
                                            }}
                                        >
                                            Copy from an existing report
                                        </li>
                                    ) : (
                                        <li
                                            id="dashboard_menu_showCopyExistingVisualUnitDialog_disabled"
                                            className="dropdown-item-disabled"
                                        >
                                            Copy from an existing report
                                        </li>
                                    )}

                                    {workspaceActions?.showReOrderOption ? (
                                        <li
                                            id="dashboard_menu_showReorderVisualUnitsDialog"
                                            className="dropdown-item cursor-pointer"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                props.onclickReorderReports()
                                                closeDropdown()
                                            }}
                                        >
                                            Reorder reports
                                        </li>
                                    ) : (
                                        <li
                                            id="dashboard_menu_showReorderVisualUnitsDialog_disabled"
                                            className="dropdown-item-disabled"
                                            title="Security privilege is not assigned for this action."
                                        >
                                            Reorder reports
                                        </li>
                                    )}

                                   
                                    <li
                                        className="dropdown-item cursor-pointer email-workspace-pdf"
                                        onClick={() => {
                                            props.onClickSendEmailasPDF()
                                            closeDropdown()
                                        }}
                                    >
                                        Email Workspace as PDF
                                    </li>
                                </>
                            )}
                        </>
                        {workspaceActions?.isHomePopUp &&
                            workspaceActions?.showEditWorkspaceOption && (
                                <li className="colorWorkspace cursor-pointer">
                                    Color this Workspace
                                </li>
                            )}
                        {workspaceActions?.isHomePopUp && (
                            <div className="color_palette_container">
                                <div className="color_palette">
                                    {[
                                        'red',
                                        'blue',
                                        'yellow',
                                        'green',
                                        'orange',
                                        'purple',
                                        'grey',
                                        'white',
                                    ].map((color) => (
                                        <div
                                            key={color}
                                            className={`chooseWorkspaceColor ${color}-workspace ${workspaceActions?.currentColor === color ? 'selected' : ''}`}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    </ul>
                </div>
            </>
        </div>
    )
}

export default WorkspaceActionsDropdown
